import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SESSION_STORAGE } from '../shared/constants/storage.constants';

@Injectable({
    providedIn: 'root',
})
export class SessionidHttpInterceptorService implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const sessionId = sessionStorage.getItem(SESSION_STORAGE.CONVERSATION_ID.key);
        return sessionId ? this.addSessionId(req, next, sessionId) : next.handle(req);
    }

    private addSessionId(req: HttpRequest<any>, next: HttpHandler, sessionId: string) {
        const existing = req.headers.get('baggage');
        const values = existing ? `${existing},sessionId=${sessionId}` : `sessionId=${sessionId}`;

        const clone = req.clone({ setHeaders: { baggage: values } });
        return next.handle(clone);
    }
}
